import { Typography } from "@mui/material";
import * as React from "react";
import { ChatListPanelHeaderContainer } from "./ChatListPanel.style";

interface ChatListPanelHeaderProps {
  header?: React.ReactNode;
}

export const ChatListPanelHeader = ({ header }: ChatListPanelHeaderProps) => {
  return (
    <>
      <ChatListPanelHeaderContainer data-testid="chatList-header">
        <>
          <Typography variant="subtitle1" sx={{
            fontWeight: 500
          }}>
            &nbsp;
            {header}
          </Typography>
        </>
      </ChatListPanelHeaderContainer>
    </>
  );
};
